import { callExternalApi } from "./external-api.service";

const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;

export const setUpdateWeekResource = async () => {
  const config = {
    url: `${tlogApiServerUrl}/api/update-week/setWeek`,
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    data: { update_week: true },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};